// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  ISetQuestionAnswerReactionWebRequest,
  TSetQuestionAnswerReactionWebModel,
  IMappers,
  TSetQuestionAnswerReactionWebResponse,
  ISetQuestionAnswerReactionWebResponse,
  ISetQuestionAnswerReactionWebResponseError,
} from './types';

export const defaultConfig: TSetQuestionAnswerReactionWebModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'newbuilding-reviews',
  pathApi: '/v1/set-question-answer-reaction-web/',
  requestType: 'json',
} as TSetQuestionAnswerReactionWebModel;

export function createSetQuestionAnswerReactionWebModel(
  parameters: ISetQuestionAnswerReactionWebRequest,
): TSetQuestionAnswerReactionWebModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ISetQuestionAnswerReactionWebOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: ISetQuestionAnswerReactionWebRequest;
}

export async function fetchSetQuestionAnswerReactionWeb<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISetQuestionAnswerReactionWebOptions<TResponse200, TResponse400>): Promise<
  TSetQuestionAnswerReactionWebResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createSetQuestionAnswerReactionWebModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISetQuestionAnswerReactionWebResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as ISetQuestionAnswerReactionWebResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TSetQuestionAnswerReactionWebResponse;
}
